export class CreateFindingExclusionPatternInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "FindingObjectType",
            "format": ""
        },
        {
            "name": "detector",
            "baseName": "detector",
            "type": "DetectorType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateFindingExclusionPatternInput.attributeTypeMap;
    }
    constructor() {
    }
}
